import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { LogErrors } from './../../../utilities/LogErrors'

import { ValidateSession } from './../../../utilities/BL/Sessions'
import { GetLearningInstruments } from './../../../utilities/BL/Student/Instruments'
import { GetLearningInstrumentsInstructors } from './../../../utilities/BL/Instructor/Instruments'

//Componentes comunes generales
import { Loading } from './../../Common/Loading'
import { InstrumentsHeader } from './../../Header/InstrumentsHeader'

//Componentes personalizados del proyecto
import { Teaching } from './Teaching/Teaching'
//import { Activity } from './../Activity/Activity'
import { Activity } from './Activity/Activity'
//import { Exam } from './../Exam/Exam'
import { Exam } from './Exam/Exam'
import { WEBPAGES } from './../../../utilities/EL/WebPages'
import { TYPE_PROPOSITION_VALUE } from './../../../utilities/EL/TypePropositionValue'
import { HELP_TYPE } from './../../../utilities/EL/HelpType'
import { ROLES } from './../../../utilities/EL/Roles'
import { BodyWithSideMenu } from './../../Dashboard/BodyWithSideMenu'

import { Header } from './../../Header/V2/Header'


const Viewer = () => {
    const navigate = useNavigate()
    
    const [activeComponent, setActiveComponent] = useState('')

    const [isLoading, setIsLoading] = useState(true)
    const [session, setSession] = useState(null)
    const [instrument, setInstrument] = useState({})
    const [theme, setTheme] = useState(null)

    const [topicName, setTopicName] = useState('') // Estado para el nombre del tema
    const [instrumentData, setInstrumentData] = useState({})
    const [isInstrumentEnabled, setIsInstrumentEnabled] = useState(null)

    // const rolesData = {
    //     ZTUDIANTE: 1,
    //     INSTRUCTOR: 2
    // }


    const LoadPage = async (sessionInfo) => {
        try {
            setTheme(sessionInfo.user.userTheme)
            
            const newSessionInfo = await ShowInstrument(sessionInfo)
            
            if (newSessionInfo) {
                setSession({ ...sessionInfo }) // Clonar objeto para forzar re-render
            }
        } catch (error) {
            await LogErrors('LoadPage - Viewer', error)
        }
    }

    const ChangeLearningInstrumentContent = async(sessionInfo) => {
        try {
            const newSessionInfo = await ShowInstrument(sessionInfo)
            
            if (newSessionInfo) {
                setSession({ ...newSessionInfo }) // Clonar objeto para forzar re-render
            }
        } catch (error) {
            await LogErrors('LoadPage - Viewer', error)
        }
    }

    const ShowInstrument = async (sessionInfo) => {
        try {
            setIsLoading(true)

            let response
            let component
            let role
            
            switch (sessionInfo.navigation.instrument.type) {
                case 1:        
                    response = {
                        success: true,
                        data: sessionInfo.navigation.instrument
                    }
                    component = 'exam'
                    break
                    
                case 2:
                    role = sessionInfo?.navigation?.role?.id
                    
                    if (role) {
                        if (role === ROLES.ZTUDENT) {     
                            response = await GetLearningInstruments(sessionInfo)
                        } else if (role === ROLES.INSTRUCTOR) {
                            response = await GetLearningInstrumentsInstructors(sessionInfo)
                        }
                        component = 'teachingMaterial'
                    }
                    break

                case 3:
                    role = sessionInfo?.navigation?.role?.id
                    
                    if (role) {
                        if (role === ROLES.ZTUDENT) {
                            response = await GetLearningInstruments(sessionInfo)
                        } else if (role === ROLES.INSTRUCTOR) {
                            response = await GetLearningInstrumentsInstructors(sessionInfo)
                        }
                        component = 'activity'
                    }
                    break
            }
            
            if (response.success) {
                setInstrument(response.data)
                setActiveComponent(component)
                SetTextOnHeader(sessionInfo)
                setIsInstrumentEnabled(sessionInfo.navigation.instrument.enabled)
                
                //return response.data
                return sessionInfo
                //console.log('¿El instrumento está habilitado?: ' + sessionInfo.navigation.instrument.enabled)
            } else {
                //Mostrar mensaje de que no se puedo obtener la info o el error
                console.log("No se pudo obtener la info: " + response.message) //Mensaje temporal
            }
        } catch (error) {
            await LogErrors('ShowInstrument - Viewer', error)
        } finally {
            setIsLoading(false)
        }
    }

    const SetTextOnHeader = async (sessionInfo) => {
        try {
            if (sessionInfo.navigation) {
                let tmpInstrumentData = {
                    block: null,
                    topic: null,
                    steps: {
                        start: null,
                        end: null
                    }
                }
                
                // Actualiza el nombre del tema
                setTopicName(sessionInfo.navigation.instrument.name)

                // Obtener el nombre del tema
                tmpInstrumentData.topic = sessionInfo.navigation.instrument.name
                
                if (sessionInfo.navigation.backToResultsView) {
                    // Establecer el nombre del examen (en lugar del nombre del bloque)
                    tmpInstrumentData.block = sessionInfo?.navigation?.instrument?.exam || null

                    // Obtener las preguntas contestadas incorrectamente para mostrar el indicador de posición
                    const availableTopics = sessionInfo?.badAnsweredQuestions
                    
                    if (availableTopics) {
                        if (availableTopics.length === 1) {
                            tmpInstrumentData.steps.start = 1
                            tmpInstrumentData.steps.end = 1
                        } else {
                            // Encontrar la posición del tema actual dentro del bloque
                            const currentIndex = availableTopics.findIndex(item => item.id === sessionInfo.navigation.instrument.id)
                
                            if (currentIndex !== -1) {
                                // Obtener la posición actual. Ej. 1 de 5
                                tmpInstrumentData.steps.start = currentIndex + 1
                                tmpInstrumentData.steps.end = availableTopics.length
                            }
                        }
                    }

                } else {
                    const blocks = sessionInfo?.courses?.blocks

                    if (blocks) {
                        // Encontrar el bloque en el que se encuentra el instrumento actual
                        const currentBlock = sessionInfo.courses.blocks.find(block =>
                            block.items.some(item => item.id === sessionInfo.navigation.instrument.id)
                        )
                        
                        if (currentBlock) {
                            // Obtener el nombre del bloque
                            tmpInstrumentData.block = currentBlock.name
        
                            if (sessionInfo.navigation.instrument.type === 2) {
                                // Filtrar los temas (type: 2) dentro de ese bloque
                                const availableTopics = currentBlock.items.filter(item => item.type === 2)
                            
                                // Encontrar la posición del tema actual dentro del bloque
                                const currentIndex = availableTopics.findIndex(item => item.id === sessionInfo.navigation.instrument.id)
                    
                                if (currentIndex !== -1) {
                                    // Obtener la posición actual. Ej. 1 de 5
                                    tmpInstrumentData.steps.start = currentIndex + 1
                                    tmpInstrumentData.steps.end = availableTopics.length
                                }
                            }
                        }
                    }
                }
                
                
                setInstrumentData(tmpInstrumentData)
            }
        } catch (error) {
            await LogErrors('SetTextOnHeader - Viewer', error)
        }
    }

    useEffect(() => {
        async function Validate() {
            const tmpSession = await ValidateSession()
            //setSession(tmpSession.data)
            
            if (tmpSession.success) {
                if (tmpSession.data.user.userStatus === 2) {
                    await LoadPage(tmpSession.data)
                } else {
                    navigate('/confirm')
                }
            } else {
                navigate(`/?logout=${process.env.REACT_APP_LOGOUT_PARAMETER}`)
            }
        }
        Validate()
    },[]) // El array vacío [] asegura que useEffect se ejecute solo una vez, al montar


    return (
        isLoading ? (
            <Loading />
        ) : (
            <>
                <BodyWithSideMenu page={WEBPAGES.ZTUDENT.VIEWER} theme={theme} propositionValue={TYPE_PROPOSITION_VALUE.ZTUDENT} idHelp={HELP_TYPE.ZTUDENT.VIEWER} role={ROLES.ZTUDENT}>
                    {/* <InstrumentsHeader instrumentData={instrumentData} theme={theme} /> CAMBIAR AQUÍ: AJUSTAR ESTO PARA MOSTRAR EL TEMA EN EL HEADER DE AQUÍ ABAJO */}
                    <Header theme={theme} setTheme={setTheme} propositionValue={TYPE_PROPOSITION_VALUE.ZTUDENT} idHelp={HELP_TYPE.ZTUDENT.VIEWER} />

                    {activeComponent.toLowerCase() === 'exam'.toLowerCase() && <Exam session={session} instrument={instrument} isInstrumentEnabled={isInstrumentEnabled} />}
                    {activeComponent.toLowerCase() === 'teachingMaterial'.toLowerCase() && <Teaching session={session} setSession={setSession} instrument={instrument} changeLearningInstrumentContent={ChangeLearningInstrumentContent} topicName={topicName} isInstrumentEnabled={isInstrumentEnabled} instrumentData={instrumentData} />}
                    {activeComponent.toLowerCase() === 'activity'.toLowerCase() && <Activity activityName={session.navigation.instrument.name} instrument={instrument} isInstrumentEnabled={isInstrumentEnabled} />}
                </BodyWithSideMenu>
            </>
        )
    )
}

export { Viewer };